import { useState } from "react";
import VideoAnalysisTabs from "./VideoAnalysisTabs";
import StoryBoard from "./StoryBoard";
import Graphics from "./Graphics";
import Technical from "./Technical";
import Scenes from "./Scenes";
import Sparkle from "@/assets/icons/SparkleGray.svg";
import { AnalysisResult } from "@/redux/feature/videoDashboard/videoDashboardType";

type DisplayAnalysisResultProps = {
  result: any;
};

export type TCurrentAnalysisTab =
  | "storyBoard"
  | "graphics"
  | "technical"
  | "scenes";

const DisplayAnalysisResult = ({ result }: DisplayAnalysisResultProps) => {
  const [currentAnalysisTab, setCurrentAnalysisTab] =
    useState<TCurrentAnalysisTab>("storyBoard");

  return (
    <section>
      <VideoAnalysisTabs
        currentAnalysisTab={currentAnalysisTab}
        setCurrentAnalysisTab={setCurrentAnalysisTab}
      />

      <div className="border border-[#00000033] rounded-lg p-3 mt-5 mb-14 overflow-y-auto">
        <h6 className="text-[#0D0D0D] leading-[120%] tracking-[0%] font-medium font-grotesk flex gap-x-1 items-center justify-center mb-4">
          {currentAnalysisTab === "storyBoard" && "Storyboard Analysis"}
          {currentAnalysisTab === "graphics" && "Graphics Analysis "}
          {currentAnalysisTab === "technical" && "Technical Analysis "}
          {currentAnalysisTab === "scenes" && "Scene Breakdown"}

          <span>
            <Sparkle />
          </span>
        </h6>

        <div className="">
          {currentAnalysisTab === "storyBoard" && (
            <StoryBoard storyboard={result.storyboard_analysis} />
          )}
          {currentAnalysisTab === "graphics" && (
            <Graphics graphics={result.storyboard_analysis.graphics_analysis} />
          )}
          {currentAnalysisTab === "technical" && (
            <Technical technical={result.technical_analysis} />
          )}
          {currentAnalysisTab === "scenes" && (
            <Scenes scenes={result.storyboard_analysis.scenes} />
          )}
        </div>
      </div>
    </section>
  );
};

export default DisplayAnalysisResult;
